/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class LedgersRoute extends Route {
  // Services
  @service
  options;

  @service
  session;

  @service
  store;

  @optionAlias('finance:xero:enableXeroIntegration')
  xeroIntegrationEnabled;

  model() {
    let schoolId = this.get('session.activeSchool');

    let model = {
      heroLedgers: this.store.query('finance/ledger', { schoolId }),
    };
    if (!this.xeroIntegrationEnabled) {
      return hash(model);
    }

    return this.store
      .query('xero/ledger', { schoolId })
      .then((xeroLedgers) => {
        model.xeroLedgers = xeroLedgers;
        return hash(model);
      })
      .catch((error) => {
        model.error = error;
        return hash(model);
      });
  }
}
